import { Controller } from "@hotwired/stimulus"

// Copies `valueValue` to the clipboard on click and flashes
// the label. Falls back to execCommand for non-secure contexts
// where the async Clipboard API is unavailable.
export default class extends Controller {
  static values = {
    value: String,
    copiedLabel: { type: String, default: "Copied" },
    resetMs: { type: Number, default: 1500 }
  }

  static targets = ["label"]

  async copy(event) {
    event.preventDefault()

    const text = this.valueValue
    if (!text) return

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text)
      } else {
        this.#fallbackCopy(text)
      }
      this.#flashCopied()
    } catch (error) {
      console.error("clipboard copy failed:", error)
    }
  }

  #fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }

  #flashCopied() {
    const el = this.hasLabelTarget ? this.labelTarget : this.element
    if (this._originalLabel === undefined) {
      this._originalLabel = el.textContent
    }
    el.textContent = this.copiedLabelValue
    clearTimeout(this._resetTimer)
    this._resetTimer = setTimeout(() => {
      el.textContent = this._originalLabel
      this._originalLabel = undefined
    }, this.resetMsValue)
  }
}
